import React, { Component } from "react";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import { SideBar, NavBar, Footer, TitleAndDescription } from "../../components";
import queryString from "query-string";
import "react-toastify/dist/ReactToastify.css";
import Pagination from "react-js-pagination";
import moment from "moment";
import { Link } from "react-router-dom";
import { UncontrolledTooltip } from "reactstrap";
import DatePicker from "react-datepicker";
const { formatarReal } = require("../../utils");

class ClienteDetalhe extends Component {
  constructor(props) {
    super(props);
    this.toggleAba = this.toggleAba.bind(this);
    this.load = this.load.bind(this);
    this.loadCliente = this.loadCliente.bind(this);
    this.loadPedidos = this.loadPedidos.bind(this);
    this.totalizadoresPedidos = this.totalizadoresPedidos.bind(this);
    this.paginar = this.paginar.bind(this);
    this.loadOrcamentos = this.loadOrcamentos.bind(this);
    this.totalizadoresOrcamentos = this.totalizadoresOrcamentos.bind(this);
    this.paginarOrcamento = this.paginarOrcamento.bind(this);
    this.loadProdutos = this.loadProdutos.bind(this);
    this.paginarProduto = this.paginarProduto.bind(this);
    this.loadClientesTop = this.loadClientesTop.bind(this);
    this.createMarkup = this.createMarkup.bind(this);
    this.loadTitulos = this.loadTitulos.bind(this);
    this.paginarTitulo = this.paginarTitulo.bind(this);
    this.formatarAgendamentoImpressao =
      this.formatarAgendamentoImpressao.bind(this);
    this.gerarImpressao = this.gerarImpressao.bind(this);
    this.abrirComprovantePedido = this.abrirComprovantePedido.bind(this);

    this.state = {
      idCliente: queryString.parse(this.props.location.search).id,
      abaAtiva: "pedidos", //orcamentos, produtos, adicionais, financeiro
      cliente: null,
      pedidos: [],
      orcamentos: [],
      produtos: [],
      titulos: [],
      totalizadorPedidos: 0,
      totalizadorOrcamentos: 0,
      totalizadorProdutos: 0,
      totalizadorTitulos: 0,
      executaBuscaOrcamentos: true,
      executaBuscaProdutos: true,
      executaBuscaTitulos: true,
      paginacao: {
        pagina: 1,
        limite: 10,
      },
      paginacaoOrcamento: {
        pagina: 1,
        limite: 10,
      },
      paginacaoProduto: {
        pagina: 1,
        limite: 10,
      },
      paginacaoTitulo: {
        pagina: 1,
        limite: 10,
      },
      descricaoTop: "",
      titulosBkp: [],
      vlDebitos: 0,
      vlCredito: 0,
      dtInicial: moment().startOf("month").toDate(),
      dtFinal: moment().endOf("month").toDate(),
      dtInicialOrcamento: moment().startOf("month").toDate(),
      dtFinalOrcamento: moment().endOf("month").toDate(),
    };
  }

  async componentDidMount() {
    await this.load();
  }

  async load() {
    await this.loadCliente();
    this.loadPedidos();
    this.loadClientesTop();
  }

  async loadCliente() {
    await axios
      .get(
        `${this.props.getBaseUrlApi()}/clientes/${this.state.idCliente}`,
        this.props.parameters()
      )
      .then((response) => {
        this.setState({ cliente: response.data.cliente });
      })
      .catch((error) => {
        console.log(error);
        if (error.response !== undefined) {
          if (error.response.status === 401) {
            this.props.logout();
          }
          if (error.response.status === 403) {
            this.props.history.push('/home')
          }
        }
      });
  }

  toggleAba(abaAlterar) {
    this.setState({ abaAtiva: abaAlterar }, () => {
      if (abaAlterar === "orcamentos") {
        if (this.state.executaBuscaOrcamentos) {
          this.loadOrcamentos();
          this.setState({ executaBuscaOrcamentos: false });
        }
      } else if (abaAlterar === "produtos") {
        if (this.state.executaBuscaProdutos) {
          this.loadProdutos();
          this.setState({ executaBuscaProdutos: false });
        }
      } else if (abaAlterar === "financeiro") {
        if (this.state.executaBuscaTitulos) {
          this.loadTitulos();
          this.setState({ executaBuscaTitulos: false });
        }
      }
    });
  }

  notificar(type, message) {
    toast[type](message, {
      position: "top-right",
      autoClose: 3000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
    });
  }

  async loadPedidos() {
    const parametros = {
      dtInicial: this.state.dtInicial,
      dtFinal: this.state.dtFinal
    }
    
    await axios
      .post(
        `${this.props.getBaseUrlApi()}/clientes/pedidos/${
          this.state.idCliente
        }?pagina=${this.state.paginacao.pagina}`,
        parametros,
        this.props.parameters()
      )
      .then((response) => {
        this.setState({ pedidos: response.data.pedidos }, () => {
          this.totalizadoresPedidos();
        });
      })
      .catch((error) => {
        console.log(error);
        if (error.response !== undefined) {
          if (error.response.status === 401) {
            this.props.logout();
          }
          if (error.response.status === 403) {
            this.props.history.push('/home')
          }
        }
      });
  }

  async totalizadoresPedidos() {
    const parametros = {
      dtInicial: this.state.dtInicial,
      dtFinal: this.state.dtFinal
    }

    await axios
      .post(
        `${this.props.getBaseUrlApi()}/clientes/pedidos-totalizadores/${
          this.state.idCliente
        }`,
        parametros,
        this.props.parameters()
      )
      .then((response) => {
        this.setState({ totalizadorPedidos: response.data.totalPedidos });
      })
      .catch((error) => {
        console.log(error);
        if (error.response !== undefined) {
          if (error.response.status === 401) {
            this.props.logout();
          }
          if (error.response.status === 403) {
            this.props.history.push('/home')
          }
        }
      });
  }

  async loadOrcamentos() {
    const parametros = {
      dtInicial: this.state.dtInicialOrcamento,
      dtFinal: this.state.dtFinalOrcamento
    }

    await axios
      .post(
        `${this.props.getBaseUrlApi()}/clientes/orcamentos/${
          this.state.idCliente
        }?pagina=${this.state.paginacaoOrcamento.pagina}`,
        parametros,
        this.props.parameters()
      )
      .then((response) => {
        this.setState({ orcamentos: response.data.orcamentos }, () => {
          this.totalizadoresOrcamentos();
        });
      })
      .catch((error) => {
        console.log(error);
        if (error.response !== undefined) {
          if (error.response.status === 401) {
            this.props.logout();
          }
          if (error.response.status === 403) {
            this.props.history.push('/home')
          }
        }
      });
  }

  async totalizadoresOrcamentos() {
    const parametros = {
      dtInicial: this.state.dtInicialOrcamento,
      dtFinal: this.state.dtFinalOrcamento
    }

    await axios
      .post(
        `${this.props.getBaseUrlApi()}/clientes/orcamentos-totalizadores/${
          this.state.idCliente
        }`,
        parametros,
        this.props.parameters()
      )
      .then((response) => {
        this.setState({ totalizadorOrcamentos: response.data.totalOrcamentos });
      })
      .catch((error) => {
        console.log(error);
        if (error.response !== undefined) {
          if (error.response.status === 401) {
            this.props.logout();
          }
          if (error.response.status === 403) {
            this.props.history.push('/home')
          }
        }
      });
  }

  async loadProdutos() {
    await axios
      .get(
        `${this.props.getBaseUrlApi()}/clientes/produtos/${
          this.state.idCliente
        }?pagina=${this.state.paginacaoProduto.pagina}`,
        this.props.parameters()
      )
      .then((response) => {
        this.setState(
          {
            totalizadorProdutos: response.data.produtos.length,
            produtosBkp: response.data.produtos,
          },
          () => {
            this.paginarProduto(1);
          }
        );
      })
      .catch((error) => {
        console.log(error);
        if (error.response !== undefined) {
          if (error.response.status === 401) {
            this.props.logout();
          }
          if (error.response.status === 403) {
            this.props.history.push('/home')
          }
        }
      });
  }

  paginar(paginaAlterar) {
    this.setState({ paginacao: { pagina: paginaAlterar, limite: 10 } }, () => {
      this.loadPedidos();
    });
  }

  paginarOrcamento(paginaAlterar) {
    this.setState(
      { paginacaoOrcamento: { pagina: paginaAlterar, limite: 10 } },
      () => {
        this.loadOrcamentos();
      }
    );
  }

  paginarProduto(paginaAlterar) {
    this.setState(
      { paginacaoProduto: { pagina: paginaAlterar, limite: 10 } },
      () => {
        let produtos = [...this.state.produtosBkp];
        paginaAlterar = paginaAlterar - 1;
        produtos = produtos.slice(
          paginaAlterar * this.state.paginacaoProduto.limite,
          (paginaAlterar + 1) * this.state.paginacaoProduto.limite
        );
        paginaAlterar = paginaAlterar + 1;

        this.setState({ produtos });
      }
    );
  }

  async loadClientesTop() {
    const idCliente = this.state.idCliente;
    let descricaoTop = "";

    let clientesTopStorage = localStorage.getItem("clientesTop");

    if (clientesTopStorage !== null) {
      clientesTopStorage = JSON.parse(clientesTopStorage);

      for (let i = 0; i < clientesTopStorage.length; i++) {
        if (idCliente === clientesTopStorage[i]) {
          descricaoTop = `TOP #${i + 1}`;
          break;
        }
      }
      this.setState({ descricaoTop });
    }

    await axios
      .get(
        `${this.props.getBaseUrlApi()}/clientes/top`,
        this.props.parameters()
      )
      .then((response) => {
        let clientes = response.data.clientes;

        for (let i = 0; i < clientes.length; i++) {
          if (idCliente === clientes[i]) {
            descricaoTop = `TOP #${i + 1}`;
            break;
          }
        }

        this.setState({ descricaoTop }, () => {
          localStorage.setItem("clientesTop", JSON.stringify(clientes));
        });
      })
      .catch((error) => {
        console.log(error);
        if (error.response !== undefined) {
          if (error.response.status === 401) {
            this.props.logout();
          }
          if (error.response.status === 403) {
            this.props.history.push('/home')
          }
        }
      });
  }

  createMarkup() {
    return { __html: this.state.cliente.obs };
  }

  async loadTitulos() {
    await axios
      .get(
        `${this.props.getBaseUrlApi()}/clientes/titulos-atraso/${
          this.state.cliente.idIntegracao
        }`,
        this.props.parameters()
      )
      .then((response) => {
        const data = response.data;

        if (data.titulos !== null) {
          this.setState(
            {
              totalizadorTitulos: data.titulos.titulos.length,
              titulosBkp: data.titulos.titulos,
              vlDebitos: data.titulos.vlDebitos,
              vlCredito: data.titulos.vlCredito,
            },
            () => {
              this.paginarTitulo(1);
            }
          );
        }
      })
      .catch((error) => {
        console.log(error);
        if (error.response !== undefined) {
          if (error.response.status === 401) {
            this.props.logout();
          }
          if (error.response.status === 403) {
            this.props.history.push('/home')
          }
        }
      });
  }

  paginarTitulo(paginaAlterar) {
    this.setState(
      { paginacaoTitulo: { pagina: paginaAlterar, limite: 10 } },
      () => {
        let titulos = [...this.state.titulosBkp];
        paginaAlterar = paginaAlterar - 1;
        titulos = titulos.slice(
          paginaAlterar * this.state.paginacaoTitulo.limite,
          (paginaAlterar + 1) * this.state.paginacaoTitulo.limite
        );
        paginaAlterar = paginaAlterar + 1;

        this.setState({ titulos });
      }
    );
  }

  async gerarImpressao(pedido) {
    let parametros = { ...pedido };

    await axios
      .post(`${this.props.getBaseUrlImpressao()}/impressao-pedido-orcamento`, {
        parametros,
      })
      .then(async (response) => {
        localStorage.setItem("html", response.data.html);
        localStorage.setItem("tituloPagina", `Comprovante do ${pedido.tipoDoc === 'pedido' ? 'Pedido' : 'Orçamento'} ${pedido.codigo}`);
        window.open("/impressao", "_blank");
      })
      .catch((error) => {
        console.log(error);
        if (error.response !== undefined) {
          // this.notificar("warning", error.response.data.erro);
        }
      });
  }

  formatarAgendamentoImpressao(novoPedido) {
    let pedido = JSON.parse(JSON.stringify(novoPedido));

    let pedidoFormatado = {
      codigo: "#" + pedido.codigo,
      tipoPedido: pedido.tipoPedido.desc,
      dataEmissao: moment(pedido.data).format("DD/MM/YYYY"),
      cliente: pedido.cliente.cnpjCpf + " - " + pedido.cliente.desc,
      endereco: {
        rua: pedido.enderecoEntrega.endereco,
        numero: pedido.enderecoEntrega.numero,
        bairro: pedido.enderecoEntrega.bairro,
        cidade: pedido.enderecoEntrega.cidade,
        uf: pedido.enderecoEntrega.estado,
        cep: pedido.enderecoEntrega.cep,
      },
      enderecoEntrega: {
        rua: pedido.enderecoEntrega.endereco,
        numero: pedido.enderecoEntrega.numero,
        bairro: pedido.enderecoEntrega.bairro,
        cidade: pedido.enderecoEntrega.cidade,
        uf: pedido.enderecoEntrega.estado,
        cep: pedido.enderecoEntrega.cep,
      },
      contato: pedido.contato.desc,
      celular: pedido.contato.cel,
      email: pedido.contato.email,
      itens: [],
      total: "",
      condicaoPagamento: pedido.condPagto.desc,
      formaPagamento: pedido.formaPagto.desc,
      transportadora: pedido.transportadora.desc,
      previsaoEntrega: moment(pedido.previsaoEntrega).format("DD/MM/YYYY"),
      ordemCompra: pedido.ordemCompra,
      vendedor: {
        desc: pedido.vendedor.desc,
        celular: pedido.vendedor.cel,
        email: pedido.vendedor.email,
      },
      empresa: {
        desc: pedido.empresa.razaoSocial,
        cnpjCpf: pedido.empresa.cnpjCpf,
        ie: pedido.empresa.ie,
      },
      tipoDoc: pedido.type,
      observacao: pedido.observacao,
    };

    let valorTotal = 0;

    for (let item of pedido.itens) {
      pedidoFormatado.itens.push({
        codigo: item.produto.cod,
        un: item.produto.unid,
        desc: item.produto.desc,
        qtd: item.quantidade,
        valorUnitario: `R$ ${formatarReal(
          item.produto.preco.precoUnitComImpostosFinal
        )}`,
        desconto: "R$ 0,00",
        totalItem: `R$ ${formatarReal(
          item.produto.preco.precoTotalComImpostosFinal
        )}`,
        obs: item.produto.obsItemNovo === undefined ? '' : item.produto.obsItemNovo
      });
      valorTotal = valorTotal + item.produto.preco.precoTotalComImpostosFinal;
    }

    console.log(pedidoFormatado);
    pedidoFormatado.total = `R$ ${formatarReal(valorTotal)}`;
    return pedidoFormatado;
  }

  abrirComprovantePedido(pedido) {
    let pedidoFormatado = this.formatarAgendamentoImpressao(pedido);
    this.gerarImpressao(pedidoFormatado);
  }

  render() {
    return (
      <React.Fragment>
        <ToastContainer
          position="top-right"
          autoClose={3000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnVisibilityChange
          draggable
          pauseOnHover
        />
        <div className="container-scroller font-app">
          <NavBar title="Detalhamento do cliente" />
          <div className="container-fluid page-body-wrapper">
            <SideBar itemActive={"carteira"} />
            <div className="main-panel">
              <div className="content-wrapper">
                {/* <TitleAndDescription
                  title="Detalhamento do cliente"
                  description="Informações completas do cliente selecionado."
                /> */}
                {this.state.cliente !== null && (
                  <React.Fragment>
                    <div className="row" style={{ lineHeight: "1.6" }}>
                      <div className="col-md-12 grid-margin stretch-card">
                        <div className="card">
                          <div className="card-body">
                            <div className="row">
                              <div className="col-md-7">
                                <div
                                  className="float-left width-100"
                                  style={{ paddingBottom: "5px" }}
                                >
                                  <span
                                    style={{
                                      fontWeight: "bold",
                                      color: "#80217e",
                                      fontSize: "17px",
                                    }}
                                  >
                                    #{this.state.cliente.cod}
                                  </span>
                                </div>

                                <div className="float-left width-100 font-size-16">
                                  <span> {this.state.cliente.desc}</span>
                                </div>

                                <div
                                  className="float-left width-100 font-size-14"
                                  style={{ minHeight: "18px" }}
                                >
                                  <span>{this.state.cliente.fantasia}</span>
                                </div>

                                <div
                                  className="float-left width-100 font-size-14"
                                  style={{ paddingTop: "20px" }}
                                >
                                  <span style={{ fontWeight: "bold" }}>
                                    Endereço principal
                                  </span>
                                </div>

                                <div className="row">
                                  <div
                                    className="col-1 d-flex"
                                    style={{
                                      justifyContent: "center",
                                      alignItems: "center",
                                    }}
                                  >
                                    <i
                                      className="fa fa-map-marker"
                                      syle="fontSize:22px"
                                      style={{
                                        fontSize: "30px",
                                        color: "#666",
                                      }}
                                    ></i>
                                  </div>

                                  <div className="col-11 font-size-14">
                                    <div>
                                      {
                                        this.state.cliente.enderecoPadrao
                                          .endereco
                                      }
                                      ,{" "}
                                      {this.state.cliente.enderecoPadrao.numero}
                                    </div>
                                    <div>
                                      {
                                        this.state.cliente.enderecoPadrao
                                          .complemento
                                      }
                                    </div>
                                    <div>
                                      {this.state.cliente.enderecoPadrao.bairro}{" "}
                                      -{" "}
                                      {this.state.cliente.enderecoPadrao.cidade}{" "}
                                      -{" "}
                                      {this.state.cliente.enderecoPadrao.estado}
                                    </div>
                                    <div>
                                      {" "}
                                      CEP:{" "}
                                      {this.state.cliente.enderecoPadrao.cep}
                                    </div>
                                  </div>
                                </div>
                              </div>

                              <div className="col-md-5">
                                <div
                                  className="float-left width-100 font-size-14"
                                  id="titulo-cliente-top"
                                  style={{
                                    paddingBottom: "5px",
                                    minHeight: "23px",
                                  }}
                                >
                                  {this.state.descricaoTop !== "" && (
                                    <span
                                      style={{
                                        fontWeight: "bold",
                                        color: "#FDCA2E",
                                      }}
                                    >
                                      <i className="fa fa-star"></i>{" "}
                                      {this.state.descricaoTop}
                                    </span>
                                  )}
                                </div>

                                <div className="float-left width-100 font-size-14">
                                  <span>
                                    CNPJ: {this.state.cliente.cnpjCpf}{" "}
                                  </span>
                                </div>
                                <div className="float-left width-100 font-size-14">
                                  <span>I.E: {this.state.cliente.ieRg} </span>
                                </div>

                                <div
                                  className="float-left width-100 font-size-14"
                                  style={{ paddingTop: "20px" }}
                                >
                                  <span style={{ fontWeight: "bold" }}>
                                    Contato principal
                                  </span>
                                </div>

                                <div className="row">
                                  <div
                                    className="col-1 d-flex"
                                    style={{
                                      justifyContent: "center",
                                      alignItems: "center",
                                    }}
                                  >
                                    <i
                                      className="fa fa-phone"
                                      syle="fontSize:22px"
                                      style={{
                                        fontSize: "30px",
                                        color: "#666",
                                      }}
                                    ></i>
                                  </div>

                                  <div className="col-11 font-size-14">
                                    <div>
                                      {this.state.cliente.contatoPadrao.desc}
                                    </div>
                                    <div>
                                      {this.state.cliente.contatoPadrao.email}
                                    </div>
                                    <div>
                                      {this.state.cliente.contatoPadrao.fone}
                                    </div>
                                    <div>
                                      {this.state.cliente.contatoPadrao.cel}
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="row">
                      <div className="col-md-12 grid-margin stretch-card">
                        <div className="card">
                          <div className="card-body">
                            <div
                              className="row font-size-16"
                              style={{
                                padding: "10px 0",
                                marginRight: "0",
                                marginLeft: "0",
                                marginBottom: "5px",
                              }}
                            >
                              <div className="table-responsive">
                                <table
                                  id="recent-purchases-listing2"
                                  className="table"
                                >
                                  <thead>
                                    <tr className="border-tab text-center">
                                      <th
                                        className={`${
                                          this.state.abaAtiva === "pedidos"
                                            ? "item-tab-detalhe-cliente-active"
                                            : "item-tab-detalhe-cliente"
                                        }`}
                                      >
                                        <a
                                          href="#"
                                          style={{ color: "inherit" }}
                                          onClick={(e) =>
                                            this.toggleAba("pedidos")
                                          }
                                        >
                                          Pedidos
                                        </a>
                                      </th>
                                      <th
                                        className={`${
                                          this.state.abaAtiva === "orcamentos"
                                            ? "item-tab-detalhe-cliente-active"
                                            : "item-tab-detalhe-cliente"
                                        }`}
                                      >
                                        <a
                                          href="#"
                                          style={{ color: "inherit" }}
                                          onClick={(e) =>
                                            this.toggleAba("orcamentos")
                                          }
                                        >
                                          Orçamentos
                                        </a>
                                      </th>
                                      <th
                                        className={`teste5 ${
                                          this.state.abaAtiva === "produtos"
                                            ? "item-tab-detalhe-cliente-active"
                                            : "item-tab-detalhe-cliente"
                                        }`}
                                      >
                                        <a
                                          href="#"
                                          style={{ color: "inherit" }}
                                          onClick={(e) =>
                                            this.toggleAba("produtos")
                                          }
                                        >
                                          Produtos +
                                        </a>
                                      </th>

                                      {/* <th
                                        className={`${
                                          this.state.abaAtiva === "financeiro"
                                            ? "item-tab-detalhe-cliente-active"
                                            : "item-tab-detalhe-cliente"
                                        }`}
                                      >
                                        <a
                                          href="#"
                                          style={{ color: "inherit" }}
                                          onClick={(e) =>
                                            this.toggleAba("financeiro")
                                          }
                                        >
                                          Financeiro
                                        </a>
                                      </th> */}

                                      {/* <th
                                        className={`${
                                          this.state.abaAtiva === "adicionais"
                                            ? "item-tab-detalhe-cliente-active"
                                            : "item-tab-detalhe-cliente"
                                        }`}
                                      >
                                        <a
                                          href="#"
                                          style={{ color: "inherit" }}
                                          onClick={(e) =>
                                            this.toggleAba("adicionais")
                                          }
                                        >
                                          Adicionais
                                        </a>
                                      </th> */}
                                    </tr>
                                  </thead>
                                </table>
                              </div>

                              {this.state.abaAtiva === "pedidos" && (
                                <React.Fragment>
                                  <div className="d-flex">
                                    <div
                                      className="form-group d-flex"
                                      style={{
                                        flexWrap: "wrap",
                                        maxWidth: "150px",
                                        marginRight: "15px",
                                      }}
                                    >
                                      <label style={{ width: "100%" }}>
                                        Data Inicial
                                      </label>
                                      <DatePicker
                                        selected={this.state.dtInicial}
                                        customInput={
                                          <input className="form-control font-size-13" />
                                        }
                                        dateFormat="dd/MM/yyyy"
                                        onChange={(dtInicial) => {
                                          this.setState({
                                            dtInicial,
                                          });
                                        }}
                                        locale="pt-BR"
                                      />
                                    </div>
                                    <div
                                      className="form-group d-flex f-wrap"
                                      style={{
                                        flexWrap: "wrap",
                                        maxWidth: "150px",
                                        marginRight: "15px",
                                      }}
                                    >
                                      <label style={{ width: "100%" }}>
                                        Data Final
                                      </label>
                                      <DatePicker
                                        selected={this.state.dtFinal}
                                        customInput={
                                          <input className="form-control font-size-13" />
                                        }
                                        dateFormat="dd/MM/yyyy"
                                        onChange={(dtFinal) => {
                                          this.setState({
                                            dtFinal,
                                          });
                                        }}
                                        locale="pt-BR"
                                      />
                                    </div>
                                    <div
                                      className="form-group"
                                      style={{ flexWrap: "wrap" }}
                                    >
                                        <i onClick={this.loadPedidos} className="fa fa-filter fa-2x" style={{cursor:"pointer", marginTop:"30px"}}></i>
                                    </div>
                                  </div>

                                  <div className="table-responsive">
                                    <table
                                      id="recent-purchases-listing"
                                      className="table"
                                    >
                                      <thead>
                                        <tr>
                                          <th>Pedido</th>
                                          <th>Negociação</th>
                                          <th>Tipo pedido</th>
                                          <th>Situação</th>
                                          <th className="text-right">
                                            Valor total
                                          </th>
                                          <th className="text-right">Data</th>
                                          <th className="text-right">Ações</th>
                                        </tr>
                                      </thead>
                                      <tbody>
                                        {this.state.pedidos.map(
                                          (pedido, key) => (
                                            <tr key={key}>
                                              <td
                                                style={{ fontWeight: "bold" }}
                                              >
                                                {/* <Link
                                                  to={`/pedido-detalhe?id=${pedido._id}`}
                                                  style={{
                                                    cursor: "pointer",
                                                    color: "inherit",
                                                  }}
                                                > */}
                                                <div
                                                  style={{ cursor: "pointer" }}
                                                  onClick={() =>
                                                    this.abrirComprovantePedido(
                                                      pedido
                                                    )
                                                  }
                                                >
                                                  #{pedido.codigo}
                                                  {/* </Link> */}
                                                </div>
                                              </td>
                                              <td>
                                                {pedido.condPagto.desc} -{" "}
                                                {pedido.formaPagto.desc}
                                              </td>
                                              <td>{pedido.tipoPedido.desc}</td>
                                              <td>
                                                <span
                                                  className={`tag ${pedido.situacao.cor.toLowerCase()}`}
                                                >
                                                  {pedido.situacao.desc}
                                                </span>
                                              </td>
                                              <td className="text-right">
                                                R${" "}
                                                {formatarReal(
                                                  pedido.valorTotal
                                                )}
                                              </td>
                                              <td className="text-right">
                                                {moment(pedido.data).format(
                                                  "DD/MM/YYYY"
                                                )}
                                              </td>
                                              <td className="text-right">
                                                {/* <Link'
                                                  to={`/pedido-detalhe?id=${pedido._id}`}
                                                  style={{ color: "initial" }}
                                                > */}
                                                <div
                                                  style={{ cursor: "pointer" }}
                                                  onClick={() =>
                                                    this.abrirComprovantePedido(
                                                      pedido
                                                    )
                                                  }
                                                >
                                                  <i
                                                    className="fa fa-search-plus"
                                                    id={`detalhar-pedido-${pedido._id}`}
                                                  ></i>

                                                  <UncontrolledTooltip
                                                    placement="right"
                                                    target={`detalhar-pedido-${pedido._id}`}
                                                  >
                                                    Detalhar pedido
                                                  </UncontrolledTooltip>
                                                  {/* </Link> */}
                                                </div>
                                              </td>
                                            </tr>
                                          )
                                        )}
                                      </tbody>
                                    </table>
                                  </div>

                                  {this.state.pedidos.length > 0 && (
                                    <div className="paginacao">
                                      <Pagination
                                        prevPageText={
                                          <i className="fa fa-angle-left" />
                                        }
                                        nextPageText={
                                          <i className="fa fa-angle-right" />
                                        }
                                        firstPageText={
                                          <i className="fa fa-angle-double-left" />
                                        }
                                        lastPageText={
                                          <i className="fa fa-angle-double-right" />
                                        }
                                        activePage={this.state.paginacao.pagina}
                                        itemsCountPerPage={
                                          this.state.paginacao.limite
                                        }
                                        totalItemsCount={
                                          this.state.totalizadorPedidos
                                        }
                                        onChange={(pagina) =>
                                          this.paginar(pagina)
                                        }
                                        itemClass="page-item"
                                        linkClass="page-link"
                                      />
                                    </div>
                                  )}
                                </React.Fragment>
                              )}

                              {this.state.abaAtiva === "orcamentos" && (
                                <React.Fragment>

<div className="d-flex">
                                    <div
                                      className="form-group d-flex"
                                      style={{
                                        flexWrap: "wrap",
                                        maxWidth: "150px",
                                        marginRight: "15px",
                                      }}
                                    >
                                      <label style={{ width: "100%" }}>
                                        Data Inicial
                                      </label>
                                      <DatePicker
                                        selected={this.state.dtInicialOrcamento}
                                        customInput={
                                          <input className="form-control font-size-13" />
                                        }
                                        dateFormat="dd/MM/yyyy"
                                        onChange={(dtInicialOrcamento) => {
                                          this.setState({
                                            dtInicialOrcamento,
                                          });
                                        }}
                                        locale="pt-BR"
                                      />
                                    </div>
                                    <div
                                      className="form-group d-flex f-wrap"
                                      style={{
                                        flexWrap: "wrap",
                                        maxWidth: "150px",
                                        marginRight: "15px",
                                      }}
                                    >
                                      <label style={{ width: "100%" }}>
                                        Data Final
                                      </label>
                                      <DatePicker
                                        selected={this.state.dtFinalOrcamento}
                                        customInput={
                                          <input className="form-control font-size-13" />
                                        }
                                        dateFormat="dd/MM/yyyy"
                                        onChange={(dtFinalOrcamento) => {
                                          this.setState({
                                            dtFinalOrcamento,
                                          });
                                        }}
                                        locale="pt-BR"
                                      />
                                    </div>
                                    <div
                                      className="form-group"
                                      style={{ flexWrap: "wrap" }}
                                    >
                                        <i onClick={this.loadOrcamentos} className="fa fa-filter fa-2x" style={{cursor:"pointer", marginTop:"30px"}}></i>
                                    </div>
                                  </div>

                                  <div className="table-responsive">
                                    <table
                                      id="recent-purchases-listing"
                                      className="table"
                                    >
                                      <thead>
                                        <tr>
                                          <th>Pedido</th>
                                          <th>Negociação</th>
                                          <th>Tipo pedido</th>
                                          <th>Validade</th>
                                          <th className="text-right">
                                            Valor total
                                          </th>
                                          <th className="text-right">Data</th>
                                          <th className="text-right">Ações</th>
                                        </tr>
                                      </thead>
                                      <tbody>
                                        {this.state.orcamentos.map(
                                          (pedido, key) => (
                                            <tr key={key}>
                                              <td
                                                style={{ fontWeight: "bold" }}
                                              >
                                                <div
                                                  onClick={() =>
                                                    this.abrirComprovantePedido(
                                                      pedido
                                                    )
                                                  }
                                                  style={{
                                                    cursor: "pointer",
                                                  }}
                                                >
                                                  #{pedido.codigo}
                                                </div>
                                              </td>
                                              <td>
                                                {pedido.condPagto.desc} -{" "}
                                                {pedido.formaPagto.desc}
                                              </td>
                                              <td>{pedido.tipoPedido.desc}</td>
                                              <td
                                                className={`${pedido.expiracao.cor.toLowerCase()}`}
                                              >
                                                {pedido.expiracao.desc}
                                              </td>
                                              <td className="text-right">
                                                R${" "}
                                                {formatarReal(
                                                  pedido.valorTotal
                                                )}
                                              </td>
                                              <td className="text-right">
                                                {moment(pedido.data).format(
                                                  "DD/MM/YYYY"
                                                )}
                                              </td>
                                              <td className="text-right">
                                                {/* <Link
                                                  to={`/orcamento-detalhe?id=${pedido._id}`}
                                                  style={{ color: "initial" }}
                                                > */}
                                                <div
                                                  style={{ cursor: "pointer" }}
                                                  onClick={() =>
                                                    this.abrirComprovantePedido(
                                                      pedido
                                                    )
                                                  }
                                                >
                                                  <i
                                                    className="fa fa-search-plus"
                                                    id={`detalhar-orcamento-${pedido._id}`}
                                                  ></i>

                                                  <UncontrolledTooltip
                                                    placement="right"
                                                    target={`detalhar-orcamento-${pedido._id}`}
                                                  >
                                                    Detalhar orçamento
                                                  </UncontrolledTooltip>
                                                  {/* </Link> */}
                                                </div>
                                              </td>
                                            </tr>
                                          )
                                        )}
                                      </tbody>
                                    </table>
                                  </div>

                                  {this.state.orcamentos.length > 0 && (
                                    <div className="paginacao">
                                      <Pagination
                                        prevPageText={
                                          <i className="fa fa-angle-left" />
                                        }
                                        nextPageText={
                                          <i className="fa fa-angle-right" />
                                        }
                                        firstPageText={
                                          <i className="fa fa-angle-double-left" />
                                        }
                                        lastPageText={
                                          <i className="fa fa-angle-double-right" />
                                        }
                                        activePage={
                                          this.state.paginacaoOrcamento.pagina
                                        }
                                        itemsCountPerPage={
                                          this.state.paginacaoOrcamento.limite
                                        }
                                        totalItemsCount={
                                          this.state.totalizadorOrcamentos
                                        }
                                        onChange={(pagina) =>
                                          this.paginarOrcamento(pagina)
                                        }
                                        itemClass="page-item"
                                        linkClass="page-link"
                                      />
                                    </div>
                                  )}
                                </React.Fragment>
                              )}

                              {this.state.abaAtiva === "produtos" && (
                                <React.Fragment>
                                  <div className="table-responsive">
                                    <table
                                      id="recent-purchases-listing"
                                      className="table"
                                    >
                                      <thead>
                                        <tr>
                                          <th>Código</th>
                                          <th>Descrição</th>
                                          <th>U.M.</th>
                                          <th className="text-right">
                                            Quantidade
                                          </th>
                                          <th className="text-right">
                                            Total do item
                                          </th>
                                        </tr>
                                      </thead>
                                      <tbody>
                                        {this.state.produtos.map(
                                          (produto, key) => (
                                            <tr>
                                              <td
                                                style={{ fontWeight: "bold" }}
                                              >
                                                #{produto.cod}
                                              </td>
                                              <td>{produto.desc}</td>
                                              <td>{produto.unid}</td>
                                              <td className="text-right">
                                                {produto.quantidadeTotal}
                                              </td>
                                              <td className="text-right">
                                                R${" "}
                                                {formatarReal(
                                                  produto.valorTotal
                                                )}
                                              </td>
                                            </tr>
                                          )
                                        )}
                                      </tbody>
                                    </table>
                                  </div>

                                  {this.state.produtos.length > 0 && (
                                    <div className="paginacao">
                                      <Pagination
                                        prevPageText={
                                          <i className="fa fa-angle-left" />
                                        }
                                        nextPageText={
                                          <i className="fa fa-angle-right" />
                                        }
                                        firstPageText={
                                          <i className="fa fa-angle-double-left" />
                                        }
                                        lastPageText={
                                          <i className="fa fa-angle-double-right" />
                                        }
                                        activePage={
                                          this.state.paginacaoProduto.pagina
                                        }
                                        itemsCountPerPage={
                                          this.state.paginacaoProduto.limite
                                        }
                                        totalItemsCount={
                                          this.state.totalizadorProdutos
                                        }
                                        onChange={(pagina) =>
                                          this.paginarProduto(pagina)
                                        }
                                        itemClass="page-item"
                                        linkClass="page-link"
                                      />
                                    </div>
                                  )}
                                </React.Fragment>
                              )}

                              {this.state.abaAtiva === "financeiro" && (
                                <React.Fragment>
                                  <div className="table-responsive">
                                    <div
                                      className="row font-size-14"
                                      style={{ marginTop: "20px" }}
                                    >
                                      <div className="col-md-4">
                                        <div>
                                          <span style={{ fontWeight: "bold" }}>
                                            Limite de crédito
                                          </span>
                                          <br /> R${" "}
                                          {formatarReal(
                                            this.state.cliente.limiteCredito
                                          )}
                                        </div>
                                      </div>

                                      <div className="col-md-4">
                                        <div>
                                          <span style={{ fontWeight: "bold" }}>
                                            Total em atraso
                                          </span>
                                          <br /> R${" "}
                                          {formatarReal(this.state.vlDebitos)}
                                        </div>
                                      </div>

                                      <div className="col-md-4">
                                        <div>
                                          <span style={{ fontWeight: "bold" }}>
                                            Créditos em aberto
                                          </span>
                                          <br /> R${" "}
                                          {formatarReal(this.state.vlCredito)}
                                        </div>
                                      </div>
                                    </div>

                                    <div
                                      className="font-size-16"
                                      style={{
                                        fontWeight: "bold",
                                        padding: "20px 0 10px 0",
                                      }}
                                    >
                                      Títulos em atraso
                                    </div>

                                    <table
                                      id="recent-purchases-listing"
                                      className="table"
                                    >
                                      <thead>
                                        <tr>
                                          <th>Título</th>
                                          <th>Observação do título</th>
                                          <th>Situação</th>
                                          <th className="text-right">Valor</th>
                                          <th className="text-right">
                                            Vencimento
                                          </th>
                                        </tr>
                                      </thead>
                                      <tbody>
                                        {this.state.titulos.map(
                                          (titulo, key) => (
                                            <tr key={key}>
                                              <td
                                                style={{ fontWeight: "bold" }}
                                              >
                                                #{titulo.nrTitulo}/1
                                              </td>
                                              <td>{titulo.desc}</td>
                                              <td>{titulo.situacao}</td>
                                              <td className="text-right">
                                                R${" "}
                                                {formatarReal(
                                                  titulo.valorPendente
                                                )}
                                              </td>
                                              <td className="text-right">
                                                {moment(titulo.emissao).format(
                                                  "DD/MM/YYYY"
                                                )}
                                              </td>
                                            </tr>
                                          )
                                        )}
                                      </tbody>
                                    </table>
                                  </div>

                                  <div className="paginacao">
                                    <Pagination
                                      prevPageText={
                                        <i className="fa fa-angle-left" />
                                      }
                                      nextPageText={
                                        <i className="fa fa-angle-right" />
                                      }
                                      firstPageText={
                                        <i className="fa fa-angle-double-left" />
                                      }
                                      lastPageText={
                                        <i className="fa fa-angle-double-right" />
                                      }
                                      activePage={
                                        this.state.paginacaoTitulo.pagina
                                      }
                                      itemsCountPerPage={
                                        this.state.paginacaoTitulo.limite
                                      }
                                      totalItemsCount={
                                        this.state.totalizadorTitulos
                                      }
                                      onChange={(pagina) =>
                                        this.paginarTitulo(pagina)
                                      }
                                      itemClass="page-item"
                                      linkClass="page-link"
                                    />
                                  </div>
                                </React.Fragment>
                              )}

                              {this.state.abaAtiva === "adicionais" && (
                                <React.Fragment>
                                  <div className="font-size-14">
                                    Observação:{" "}
                                    <div
                                      dangerouslySetInnerHTML={this.createMarkup()}
                                    ></div>
                                  </div>
                                </React.Fragment>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </React.Fragment>
                )}
              </div>
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

export default ClienteDetalhe;
